import HttpService from './http.service';

class VesselService {
  getVessels() {
    return HttpService.get('vessels')
      .then((res) => res.data);
  }

  getVessel(id) {
    return HttpService.get(`vessels/${id}`)
      .then((res) => res.data);
  }

  createVessel(vessel) {
    return HttpService.post('vessels', vessel)
      .then((res) => res.data);
  }

  updateVessel(vessel) {
    return HttpService.patch(`vessels/${vessel.id}`, vessel)
      .then((res) => res.data);
  }

  deleteVessel(vessel) {
    return HttpService.delete(`vessels/${vessel.id}`)
      .then((res) => res.data);
  }
}

export default new VesselService();
